<!--
 @description 服务监控-应用性能
 @author xiehan
 @date 2018/11/07
-->
<template>
  <div class="serverDetailPerformance__content">
    <g-back :history="history"></g-back>
    <el-tabs v-model="activeName" type="border-card">
      <!-- 应用 tab -->
      <el-tab-pane :label="app" name="app">
        <app-status-app-tab :app="app" :group="group" :ip="ip" :port="port" :reset="reset"></app-status-app-tab>
      </el-tab-pane>
      <!-- 主机性能tab -->
      <el-tab-pane :label="$t('serverMonitor.hostPerformance')" name="host">
        <app-status-host-tab :app="app" :group="group" :ip="ip" :port="port" :reset="reset" :active="activeName"></app-status-host-tab>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import appStatusAppTab from '@/views/component/serverMonitor/appStatusAppTab.vue'
  import appStatusHostTab from '@/views/component/serverMonitor/appStatusHostTab.vue'
  export default {
    data () {
      return {
        history: [],
        app: '',
        group: '',
        ip: '',
        port: '',
        activeName: 'app',
        reset: '',
        siteList: {}
      }
    },
    components: {
      appStatusAppTab,
      appStatusHostTab
    },
    methods: {
      getSiteList () {
        SiteListBiz.siteList({perPageCount: 500}).then((data) => {
          let list = {}
          data.dataList.map((item) => {
            list[item.siteCode] = item.name
          })
          this.siteList = list
          this.setHistory()
        })
      },
      init () {
        this.group = this.$route.query.group
        this.app = this.$route.query.app
        this.ip = this.$route.query.ip.split('_')[0]
        this.port = this.$route.query.ip.split('_')[1]
        this.setHistory()
        this.activeName = 'app'
        this.reset = `${this.group}${this.app}${this.ip}${this.port}`
      },
      setHistory () {
        this.history = []
        this.history = [{
          name: `${this.$t('serverMonitor.serverMonitor')}(${this.siteList[this.$route.query.siteCode]})`
        }, {
          name: this.group,
          path: `/home/serverMonitor/serverAppList?group=${this.group}&siteCode=${this.$route.query.siteCode}`
        }, {
          name: this.app,
          path: `/home/serverMonitor/serverDetail?app=${this.app}&group=${this.group}&siteCode=${this.$route.query.siteCode}`
        }, {
          name: this.port ? `${this.ip}:${this.port}` : this.ip
        }]
      },
      back (i) {
        this.activeName = 'app'
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'serverDetailPerformance' && from.name === 'serverDetail') {
          this.init()
        }
      }
    },
    mounted () {
      this.init()
      this.getSiteList()
    }
  }
</script>

<style>

</style>